<app-emptyorders *ngIf="noData || !tokenExists"></app-emptyorders>
<app-loading *ngIf="contentReady"></app-loading>
<div class="addresses-container bg-light" *ngIf="!noData" style="margin-bottom: 70px;">
    <div class="order-card" *ngFor="let order of allData; let isFirst = first">
        <div class="order-id" style="text-align: center;">
            <ng-container [ngSwitch]="order.order_status">

                <img src="/assets/e-commerce/icons/67.webp" *ngSwitchCase="1" alt="product" class="product-img">
                <img src="/assets/e-commerce/icons/68.webp" *ngSwitchCase="2" alt="product" class="product-img">
                <img src="/assets/e-commerce/icons/69.webp" *ngSwitchCase="3" alt="product" class="product-img">
                <img src="/assets/e-commerce/icons/70.webp" *ngSwitchCase="4" alt="product" class="product-img">
                <img src="/assets/e-commerce/icons/71.webp" *ngSwitchDefault alt="product" class="product-img">

            </ng-container>

            <br>
            <ng-container [ngSwitch]="order.order_status">
                <span class="status status-pending order-status-pending" *ngSwitchCase="1">{{ "pending" | transloco }}

                </span>
                <span *ngSwitchCase="2" class="status status-approved order-status-approved">{{ "approved" | transloco}}


                </span>
                <span *ngSwitchCase="3" class="status status-rejected order-status-rejected">
                    {{ "rejected" | transloco }}
                </span>
                <span *ngSwitchCase="4" class="status status-ontheway order-status-ontheway">{{ "on the way" | transloco
                    }}

                </span>
                <span *ngSwitchDefault class="status status-shipped order-status-shipped">{{ "shipped" | transloco }}
                </span>




            </ng-container>
            @if(order.delivery_hero != null && order.order_status != "5" && order.order_status != "3" ){
            <br>
            {{ "your order delivery hero" | transloco }}

            <div class="order-price">{{order.delivery_hero}}</div>
            <div class="order-actions" style="text-align: center;">
                <br>

                <span class="status status-call pointer" (click)='callHero(order.delivery_hero)'>
                    {{ "call hero" | transloco }}
                </span>

                <span (click)='chatWithHero(order.delivery_hero)' class="status status-call pointer">

                    {{ "chat with hero" | transloco }}
                </span>

            </div>
            }

            <br>

            {{convertDate(order.created_at)}}
            <br>
            {{ "order number" | transloco }} <div class="order-price">#{{order.id}}</div>

            {{ "total" | transloco }}
            <div class="order-price"> {{order.total}} {{ "egpe" | transloco }}


                <br>

            </div>

        </div>

        <div class="order-actions" style="text-align: center;">
            <br>
            @if(order.order_status == "5" || order.order_status == "3"){
            <span (click)="reorder(order.product_id,order.quantity)" class="status status-ontheway pointer">
                {{ "reorder" | transloco }}

            </span>
            }
            <span class="status status-shipped pointer" (click)='details(order)'>
                {{ "order details" | transloco }}

            </span>
            @if(order.order_status != "3" && order.order_status == "5"){
            <span *ngIf="canRefund(order.created_at)" class="status status-pending pointer">
                {{ "refund" | transloco }}
            </span>
            }
            <span class="status status-approved pointer" (click)='invoice(order)'>
                {{ "details" | transloco }}
            </span>
            @if(order.order_status != "5" && order.order_status != "4"){
            <span *ngIf='order.order_status != "3"' (click)='orderStatuschange(order.id,3)'
                class="status status-rejected pointer">
                {{ "Cancel" | transloco }}

            </span>
            }
        </div>



    </div>


</div>

<!--       <div [ngSwitch]="order.payment_type">
                        <div *ngSwitchCase="'0'">{{ "cash" | transloco }}</div>
                        <div *ngSwitchCase="'1'">{{ "vodafone cash" | transloco }} </div>
                        <div *ngSwitchCase="'2'">{{ "instapay" | transloco }} </div>
                        <div *ngSwitchCase="'3'">{{ "online payment" | transloco }} </div>
                        <div *ngSwitchCase="'4'">{{ "bank transfer" | transloco }} </div>
                        <div *ngSwitchCase="'5'">{{ "credit" | transloco }} </div>

                    </div> -->